import { ref } from "vue";

export function useSearch() {
    const showSearchField = ref(false);

    return { showSearchField };
}